import React, { Fragment } from 'react'
import Navbar from '../../components/Navbar/Navbar'

import Logo from '../../images/logo-01.png'
import Phone from '../../images/telephone.svg'
import Hero3 from '../../components/hero3/hero3';
import About2 from '../../components/about2/about2';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import Scrollbar from '../../components/scrollbar/scrollbar';
import CursorMaus from '../../components/CursorMaus/CursorMaus';
import FunFact from '../../components/FunfactSection/FunfactSection';
import TestimonialSection from '../../components/TestimonialSection/TestimonialSection';
import ContactForm from '../ContactPage/ContactForm';
import Footer from '../../components/footer/Footer';


function Index() {

   const submitHandler = (e) => {
        e.preventDefault()
    }

  return (
    <div>
     
     <Fragment>
        <Navbar  Logo={Logo} telephone={Phone} hclass={"wpo-site-header s3"} />
        <Hero3/>
        <About2/>
        <ServiceSection hclass={'services-section'} />
        <FunFact  hclass="funfact-section s2 mt-1"  />
         <BlogSection/>
          <TestimonialSection />
        <ContactForm/>
        <Footer/>

        <Scrollbar/>
        <CursorMaus/>

     </Fragment>

    </div>
  )
}

export default Index
